import { DOCUMENT } from '@angular/common';
import { Component, effect, inject, input, OnDestroy } from '@angular/core';
import { Loader } from '../../../services/loader.service';

@Component({
  selector: 'app-loader-overlay',
  standalone: true,
  templateUrl: './loader-overlay.html',
  styleUrl: './loader-overlay.scss',
})
export class LoaderOverlay implements OnDestroy {
  readonly message = input('Loading...');
  readonly useGlobalState = input(true);
  readonly visible = input(false);

  readonly dots = Array.from({ length: 12 });

  private readonly loadingService = inject(Loader);
  private readonly document = inject(DOCUMENT);
  private readonly originalBodyOverflow = this.document.body.style.overflow;

  constructor() {
    effect(() => {
      this.document.body.style.overflow = this.isVisible() ? 'hidden' : this.originalBodyOverflow;
    });
  }

  isVisible(): boolean {
    return this.useGlobalState() ? this.loadingService.isLoading() : this.visible();
  }

  ngOnDestroy(): void {
    this.document.body.style.overflow = this.originalBodyOverflow;
  }
}
